import Operation from './Operation.js';
import {duplicateParameterAutomations} from './parameterAutomations.js';
import MoveSelection from './MoveSelection.js';
import DeleteSelection from './DeleteSelection.js';
import InsertRollEvent from './InsertRollEvent.js';
import InsertEvent from './InsertEvent.js';
import PasteSelection from './PasteSelection.js';
import {
    constructEvent,
    NO_SUB_SEQUENCE,
    SEQUENCE_ROLL} from 'session/constants.js';

const DETERMINISTIC = 'DETERMINISTIC';
const LINEAR = 'LINEAR';
const BASIC = 'BASIC';

class DuplicateSelection extends PasteSelection {
    constructor(mix, selection, mixType) {
        super(mix, undefined, selection, mixType);
        this.step = this.end;
    }

    get duration() {
        return this.end - this.start;
    }

    execute() {
        // first move selection
        let selection = {start: this.end};
        new MoveSelection(
            this.mix,
            this.end + this.duration,
            selection)
            .execute();
        
        super.execute();

        duplicateParameterAutomations(this.mix.subSequence, this.start, this.end);
    }

    async executeForTrack() {
        let track = this.mix.subSequence.tracks[0];
        this.splitIntersectingPatterns(track);

        // first see if any patterns overlap the start and end points
       
        // then move all patterns past this.end
        let offset = this.end - this.start;
        let patternsAfterEnd = track.patterns
            .filter(
                pattern => pattern.startStep >= this.end)
            .forEach(
                pattern => pattern.startStep += offset);

        // then finally copy the selection and paste it right after
        for (let i in track.patterns) {
           let pattern = track.patterns[i];
            if (pattern.startStep >= this.start && pattern.startStep < this.end) {
                let offset = pattern.startStep - this.start;
                let copiedPattern = await pattern.getCopy();
                copiedPattern.startStep = this.end + offset;
                track.patterns.push(copiedPattern);
            }
        }

        track.updateSteps();
    }
}

export default DuplicateSelection;
